import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IQaModel} from '../../../core/models/qa.model';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css']
})
export class QuestionComponent implements OnInit {
  @Input() qaData: IQaModel = {} as IQaModel;
  @Input() index: number;
  @Output() doEdit = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  edit() {
    this.doEdit.emit();
  }
  delete() {
    this.doDelete.emit();
  }
}
